import { FC } from 'react';
import styled from '@emotion/styled';
import Started from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/Started';
import isEmpty from 'lodash/isEmpty';
import useWindowSize from '@hooks/useWindowSize';
import useDst from '@api/hooks/goal/test-series/useDST';
import Unattempted from './Unattempted';
import Result from './Result';
import { DST_STATES } from './utils';

const Container = styled.div`
  position: relative;
  grid-column: span 18;
`;

type DSTProps = {
  goalUID: string;
  goalSlug: string;
  goalName: string;
};

const DST: FC<DSTProps> = ({ goalUID, goalSlug, goalName }) => {
  const { dstData: data } = useDst(goalUID, goalName, 'Tests');
  const { isMobile } = useWindowSize();

  if (isMobile) return null;

  if (isEmpty(data)) return null;

  switch (data.data[0].state) {
    case DST_STATES.UNATTEMPTED:
      return (
        <Container>
          <Unattempted
            data={data}
            goalUID={goalUID}
            goalSlug={goalSlug}
            goalName={goalName}
          />
        </Container>
      );

    case DST_STATES.RESUME:
    case DST_STATES.ATTEMPTED:
      return (
        <Container>
          <Started
            data={data}
            goalUID={goalUID}
            goalName={goalName}
            lps="Tests"
          />
        </Container>
      );

    case DST_STATES.REATTEMPT:
    case DST_STATES.WON:
      return (
        <Container>
          <Result
            data={data}
            goalUID={goalUID}
            goalSlug={goalSlug}
            goalName={goalName}
            lps="Tests"
          />
        </Container>
      );

    default:
      return null;
  }
};

export default DST;
